import React from 'react';

import { formatPercentage } from '../../../utils/formatters';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';

export default function LotteryRuleTierDetails({ tier }) {
    return (
        <Card title="Tier details">
            <TableDetailsBody>
                <Row label="Name">{tier.name}</Row>
                <Row label="Slug">{tier.slug}</Row>
                <Row label="Lottery rule tier in kind prize id">{tier.lottery_rule_tier_in_kind_prize_id}</Row>
                <Row label="Lottery game type id">{tier.lottery_game_type_id}</Row>
                <Row label="Matches">{tier.matches}</Row>
                <Row label="Prize type">{tier.prize_type}</Row>
                <Row label="Prize fund percent">{formatPercentage(tier.prize_fund_percent)}</Row>
                <Row label="Odds">{formatPercentage(tier.odds)}</Row>
                <Row label="Prize">{tier.prize}</Row>
                <Row label="Currency code">{tier.currency_code}</Row>
                <Row label="Is jackpot">{tier.is_jackpot}</Row>
                <Row label="Display order">{tier.display_order}</Row>
            </TableDetailsBody>
        </Card>
    );
}
